import React, { useState } from "react";
import { Rating } from "react-simple-star-rating";
import config from "../config";

function Card({ title, text,views, rating, address, image }) {
  const [imagePath, setImagePath] = useState(config.BaseUrl + image);

  function truncateText(str, maxChars) {
    return str.length > maxChars ? str.slice(0, maxChars) + "…" : str;
  }

  return (
    <div className="card">
      <img src={imagePath} className="card-image" />
      <h4>{title}</h4>
      <p>{truncateText(text, 50)}</p>

        <i class="fa-regular fa-eye"/> {views} 
      <div>
        <Rating allowFraction={true} initialValue={rating} readonly={true} />
      </div>
      <p>{address}</p>
    </div>
  );
}

export default Card;
